import { FC, ReactNode } from "react";

import { IRideDto } from "@ryde/shared";

import { StationDurationTooltip } from "../../../tooltips";

interface IRideStationDurationTooltip {
  rideDto: Partial<IRideDto> | undefined;
  stationIndex: number;
  children: ReactNode;
}

export const RideStationDurationTooltip: FC<IRideStationDurationTooltip> = ({
  rideDto,
  stationIndex,
  children,
}) => {
  return (
    <StationDurationTooltip rideDto={rideDto} stationIndex={stationIndex}>
      {children}
    </StationDurationTooltip>
  );
};
